import { useLanguage } from '../contexts/LanguageContext';
import translations from '../translations';

/**
 * Custom hook for accessing translations
 * @returns {Function} - Translation function that takes a key path
 */
export const useTranslation = () => {
  const { language } = useLanguage();
  
  // Function to get a nested value from object using dot notation
  const getNestedValue = (obj, path) => {
    const keys = path.split('.');
    return keys.reduce((o, key) => (o && o[key] !== undefined ? o[key] : undefined), obj);
  };
  
  // Translation function
  const t = (key, replacements = {}) => {
    // Get the translation from the current language
    const translationObj = translations[language] || translations.en;
    let text = getNestedValue(translationObj, key);
    
    // Fallback to English if translation not found
    if (text === undefined && language !== 'en') {
      text = getNestedValue(translations.en, key);
    }
    
    // If still undefined, return the key
    if (text === undefined) {
      return key;
    }
    
    // Replace any placeholders like {{count}}
    return Object.entries(replacements).reduce(
      (str, [key, value]) => str.replace(new RegExp(`{{${key}}}`, 'g'), value),
      text
    );
  };
  
  return t;
};
